import React from 'react';
import { useSelector } from 'react-redux';
import FormNavigation from 'components/FormNavigation';
import FormContainer from 'components/LoanForm/FormContainer';
import Button from 'components/Button';
import { ButtonType } from 'components/Button/Button';
import StudentLoanLoaderWrapper from 'components/StudentLoanForgiveness/LoaderWrapper';
import { InfoNote } from 'components/StudentLoanForgiveness/Common/ResultBlocks';
import { getSavingsLabel } from 'components/StudentLoanForgiveness/studentLoanFormat';
import { LaterScreenResult } from 'enums/StudentLoanForgivenessFlowResults';
import { FlowComponentType } from 'routes/types';
import { getStudentLoanData, getStudentLoanPlanResult } from 'selectors/getStudentLoanData';

import commonStyles from 'components/StudentLoanForgiveness/Common/Common.module.scss';

const Later = ({ navigationInfo, handleNext }: FlowComponentType) => {
  const planResult = getStudentLoanPlanResult(useSelector(getStudentLoanData));
  const savingsLabel = planResult ? getSavingsLabel(planResult) : null;

  return (
    <StudentLoanLoaderWrapper>
      <>
        <FormNavigation {...navigationInfo} />
        <FormContainer
          title="Your estimate is saved"
          subtitle="Come back with your studentaid.gov file and we'll refine it into a plan with steps."
        >
          {savingsLabel && <InfoNote title="Estimated savings" body={savingsLabel} />}

          <div className={commonStyles.buttons}>
            <Button onClick={() => handleNext(LaterScreenResult.UploadNow)}>Upload my file now</Button>
            <Button type={ButtonType.Transparent} onClick={() => handleNext(LaterScreenResult.Done)}>
              Done
            </Button>
          </div>
        </FormContainer>
      </>
    </StudentLoanLoaderWrapper>
  );
};

export default Later;
